import React from "react";
import "./select.css";

function Select({ className, children, placeholder, required, onChange, value, defaultValue }) {
  let isRequiredClass = required ? "select-required" : "";
  let classes = ["select-primary", className, isRequiredClass].join(" ");
  let _onChange = undefined;
  _onChange = e => {
    e.target.classList.add("selected");
  };

  function handleOnChange(e) {
    if (_onChange) _onChange(e);
    if (onChange) onChange(e);
  }

  let options = [];
  let childrenIsArray = Array.isArray(children)
  for (let option in children) {
    let key = option;
    let value = children[option];
    if (childrenIsArray) [key, value] = [value, key]
    options.push(<option value={value} key={key}>{key}</option>);
  }

  if (placeholder !== undefined)
    options = [
      <option hidden value="-1" key="-1">
        {placeholder}
      </option>,
      ...options
    ];

  return (
    <select className={classes} onChange={handleOnChange} defaultValue={defaultValue || -1} value={value}>
      {options}
    </select>
  );
}

export default Select;
